import { useEffect, useState } from "react";
import { usePrevious } from "./usePrevious";

interface WindowSize {
  width: number|null;
  height: number|null;
  outerWidth: number|null;
  outerHeight: number|null;
  documentWidth: number|null;
  documentHeight: number|null;
}
export interface WindowSizeInfo extends WindowSize{
  previous: WindowSize|undefined;
}
export function useWindowSize(): WindowSizeInfo{
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: null,
    height: null,
    outerWidth: null,
    outerHeight: null,
    documentWidth: null,
    documentHeight: null,
   });
  const previous = usePrevious(windowSize);
  useEffect(() => {
    const updateWinSize = () => {
      if (window) {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
          outerWidth: window.outerWidth,
          outerHeight: window.outerHeight,
          documentHeight: document.documentElement.clientHeight,
          documentWidth: document.documentElement.clientWidth,
        });
      }
    }
    window.addEventListener("resize", updateWinSize);
    updateWinSize();
    return () => window.removeEventListener("resize", updateWinSize);
  }, []);
  return {...windowSize, previous: previous};
}